enum availableColors {
  SUCCESS = 'success',
  INFO = 'info',
  ERROR = 'error',
  WARNING = 'warning'
}

export function eventTypeColor(value: number): string {
  if (value === 0) {
    return availableColors.SUCCESS;
  }

  return availableColors.INFO;
}
